import { Component, inject } from '@angular/core';
import { ProduktlisteFormComponent } from '@features/produktlister/produktliste-form/produktliste-form.component';
import { Panel } from 'primeng/panel';
import { ProduktlisteResultComponent } from '@features/produktlister/produktliste-result/produktliste-result.component';
import { ProduktlisterService } from '@features/produktlister/produktlister.service';

@Component({
  selector: 'app-produktlister',
  imports: [
    ProduktlisteFormComponent,
    Panel,
    ProduktlisteResultComponent,
  ],
  templateUrl: './produktlister.component.html',
  styleUrl: './produktlister.component.css'
})
export class ProduktlisterComponent {
  plService = inject(ProduktlisterService);

}
